var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgProfileDocument = function SvgImgProfileDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img-profile-document_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.84 61.298V17.471H17.49V65.65c0 2.39 1.95 4.351 4.34 4.351l37.04-.87.97-7.841v.01Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.83 69.85c2.39 0 4.34-1.96 4.34-4.35v-6.452h38.01v4.28c0 3.591-2.93 6.532-6.51 6.532H21.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.83 69.85c2.39 0 4.34-1.96 4.34-4.35v-6.452h38.01v4.28c0 3.591-2.93 6.532-6.51 6.532H21.83M25.74 27.723h12.81M25.74 32.854h12.81M25.74 37.985h6.41",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 10H49.36v23.824h10.05l2.27 3.94 2.28-3.94H74V10Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.68 29.523a7.81 7.81 0 0 0 7.81-7.811 7.81 7.81 0 1 0-15.62 0 7.81 7.81 0 0 0 7.81 7.811Z",
    fill: "#006DFF",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78 27.783a7.804 7.804 0 0 0 4.9 1.74c1.85 0 3.56-.65 4.9-1.74a7.804 7.804 0 0 0-4.9-1.74c-1.85 0-3.56.65-4.9 1.74ZM61.68 23.792a3.12 3.12 0 1 0 0-6.24 3.12 3.12 0 0 0 0 6.24ZM21.75 42.965H6v15.223h6.42l1.46 2.52 1.45-2.52h6.42V42.965Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 50.637c0-1.89-1.53-3.42-3.42-3.42s-3.42 1.53-3.42 3.42 1.53 3.42 3.42 3.42 3.42-1.53 3.42-3.42Z",
    fill: "#E5F0FF",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "img-profile-document_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgImgProfileDocument;